import React from 'react';
import { Neo } from '@singularsystems/neo-react';
import { ReportingView } from '@singularsystems/neo-reporting';
import { IReportType } from '@singularsystems/neo-reporting/dist/Models/IReportType';
import { MaintenanceReportCategories } from './MaintenanceReportCategories';

export default class MaintenanceReportsView extends ReportingView {
    protected renderReportListSection() {
        var maintenanceReportsCategories = Object.values(MaintenanceReportCategories).toString();
        const allReports = this.viewModel.reportingService.reports.groupBy(c => c.reportInfo.category, (c, i, d) => ({ category: c, reports: d }));;

        let maintenanceReports: {
            category: string,
            reports: IReportType[],
        }[] = [];

        allReports.forEach((report) => {
            if (maintenanceReportsCategories.includes(report.category)) {
                maintenanceReports.push(report);
            }
        });

        let categoryCards: JSX.Element[];
        if (this.mustArrangeReportCards) {
            categoryCards = this.arrangeReportCardColumns(maintenanceReports);
        }
        else {
            categoryCards = this.renderReportList(maintenanceReports);
        }

        return ( <Neo.GridLayout xl={3}>
            {categoryCards}
        </Neo.GridLayout> )
    }
}